import styled from '@emotion/styled';
import { motion } from 'motion/react';

import { createClassNames } from '@hrworks/design-system/functions';
import { mq, resetListStyles } from '@hrworks/design-system/utilities';

const componentConfig = {
  indicatorWidth: 1,
};

const IconContainer = styled.span(({ theme }) => ({
  display: 'inline-flex',
  alignSelf: 'stretch',
  alignItems: 'center',
  padding: `${theme.eclipseTier1.spacing['8px']} 0 ${theme.eclipseTier1.spacing['8px']} ${theme.eclipseTier1.spacing['8px']}`,
}));

const IconWrapper = styled.span<{
  expanded: boolean;
}>(({ theme, expanded }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  [mq.conditionalTransition]: {
    // TODO: Migrate animationDuration to eclipse tokens (no eclipse motion tokens yet)
    transition: `transform ${theme.marko.variables.animationDuration.normal}`,
  },
  ...(!expanded && {
    transform: 'rotate(-90deg)',
  }),
}));

const Submenu = styled(motion.div)({
  overflow: 'hidden',
  '[data-showcollapsiblemenudepthindicator=true] &': {
    position: 'relative',
    '::before': {
      content: '""',
      position: 'absolute',
      left: 'var(--line-position-depth-indicator)',
      top: 0,
      bottom: 0,
      width: componentConfig.indicatorWidth,
      zIndex: 1,
      backgroundColor: 'var(--collapsible-menu-depth-indicator-color)',
      pointerEvents: 'none',
    },
  },
});

const SubmenuList = styled.ul([resetListStyles]);

const components = { IconContainer, IconWrapper, Submenu, SubmenuList };

export const S = {
  componentConfig,
  ...components,
  ...createClassNames('CollapsibleMenuEntry', components),
} as const;
